<svg class="svg_icon--toggle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
<defs>
	<style>.svg_icon--toggle .icon{fill:currentColor;}</style>
</defs>
<path class="icon" d="M13.7,40.7c6.3,7.6,12.4,13.4,16.5,17.3c4.4,4.3,10.9,10,13.8,12.2c3,2.4,7.9,2.2,11.1-0.3c2.9-2.1,11.3-9.7,14.9-13.7
	c4.8-5.2,10.6-10.1,16-16c1.9-1.9,2.3-4.7,1.1-7.2c-1.5-3-5.1-4-8.1-2.5c-0.6,0.3-1.1,0.8-1.6,1.3c-5.2,5.5-7.3,8.5-12.7,13.8
	c-2.4,2.3-7.4,7.9-11,11.1c-2.4,2.1-5.6,2.1-8.9-0.3c-3.2-2.4-6-5.7-10.3-9.9c0,0-6.3-6.7-12.2-14.1c-1.3-1.4-3-2.3-5-2.1
	c-1.9,0.1-3.6,1.2-4.6,2.8C11.7,35.7,12,38.7,13.7,40.7z"/>
</svg>